<template>
    <div class="gap-general platforms_landings landing_mt5">
        <!-- <PreloaderPage /> -->
        <BannerPages
            :title="'platforms_landigs.banner.title1'"
            :descriptions="[
                $t('platforms_landigs.banner.descript1'),
            ]"
            :img="'/images/platforms/2.MT5_Img-Hero.png'"
            mainImageWidthDesk="640"
            mainImageHeightDesk="549"
            alt="Tradeview MT5"
            :buttons="[
                {
                    type: 'external',
                    href: getExternalUrl('/register/1/live-account'),
                    class: 'primary-button-medium',
                    text: 'platforms_landigs.banner.text_button' 
                }
            ]"
        />

        <LazyWhatIsMAM 
            :title="title2"
            :content="content"
        />

        <div class="deg-platform" :style="degrade"></div>

        <LazyDoForYouMAM
            :title="title3"
            :cards="cards"
            class="var_icons"
        />

        <client-only>
            <LazyInvestment
                class="var-invest"
                :label="'platforms_landigs.pre_footer.title1'"
                :cont_descript2="true"
                :buttonConfigs="[
                    {
                        type: 'external',
                        href: getExternalUrl('/register/1/live-account'),
                        class: 'primary-button-medium',
                        textKey: 'platforms_landigs.pre_footer.btn_1'
                    },
                    {
                        type: 'os-link',
                        osLinks: {
                            windows: 'https://download.mql5.com/cdn/web/tradeview.ltd/mt5/tradeview5setup.exe',
                            android: 'https://download.mql5.com/cdn/mobile/mt5/android?server=TradeviewEurope-Demo',
                            mac: 'https://download.mql5.com/cdn/web/metaquotes.software.corp/mt5/MetaTrader5.dmg?utm_source=www.metatrader5.com&utm_campaign=download',
                            ios: 'https://download.mql5.com/cdn/mobile/mt5/ios?server=TradeviewEurope-Demo'
                        },
                        class: 'second-button-medium-white',
                        textKey: 'platforms_landigs.pre_footer.btn_2'
                    }
                ]"
            />
        </client-only>
    </div>
</template>
  
<script setup>
    import LazyWhatIsMAM from "~/components/services/multi_mam/WhatIsMAM.vue";
    import LazyDoForYouMAM from "~/components/services/multi_mam/DoForYouMAM.vue";
    // import PreloaderPage from "~/components/PreloaderPage.vue";
    import { useI18n } from "vue-i18n";
    import { useExternalUrl } from '@/composables/useExternalUrl';
    import { useImage } from '#imports';

    const { t } = useI18n();
    const { getExternalUrl } = useExternalUrl();

    const nuxtImg = useImage();

    const title = t("seo.mt5.title");
    const description = t("seo.mt5.description");
    const imgSeo = 'https://tradeview.eu/images/seo/25MT5.jpg'

    useSeoMeta({
        title: title,
        ogTitle: title,
        twitterTitle: title,
        description: description,
        ogDescription: description,
        twitterDescription: description,
        ogImage: imgSeo,
        twitterImage: imgSeo
    });

    const degradadeImageUrl = '/images/platforms/3.MT5_Gradient.avif';
    
    const optimizedDegrade = nuxtImg(degradadeImageUrl, {
        quality: 50,
        format: 'avif',
    });

    const degrade = computed(() => {
        return {
            '--degrade': `url('${optimizedDegrade}')`,
        };
    });

    const title2 = t('platforms_landigs.what-is.title1');
    const content = [
        [
            { text: t('platforms_landigs.what-is.text1'), strong: false },
        ],
    ];
    
    const title3 = ("platforms_landigs.advantages.title1");
    
    const cards = [
        {
            icon: "stacks",
            description1: t("platforms_landigs.advantages.text_6"),
        },
        {
            icon: "analytics",
            description1: t("platforms_landigs.advantages.text_7"),
        },
        {
            icon: "border_color",
            description1: t("platforms_landigs.advantages.text_8"),
        },
        {
            icon: "family_history",
            description1: t("platforms_landigs.advantages.text_9"),
        },
        {
            icon: "support_agent",
            description1: t("platforms_landigs.advantages.text_10"),
        }
    ]; 
</script>
  